import { Plus } from 'lucide-react';
import { Link } from 'react-router-dom';

import { usePermissions } from '../../../hooks/usePermissions';
import { Permission } from '../../../types/permissions';
import { NEW_GIFT_PASS_BUNDLE_PATH } from '../gift-pass-bundles-paths';

import './gift-pass-bundles-list.css';

export function NewGiftPassBundleButton() {
  const { hasPermission } = usePermissions();
  if (!hasPermission(Permission.WRITE_GIFT_PASS_BUNDLES)) return null;

  return (
    <Link
      to={NEW_GIFT_PASS_BUNDLE_PATH}
      className="nb-btn nb-btn-primary gpb-new-btn"
      aria-label="New bundle"
    >
      <Plus size={15} aria-hidden />
      New<span className="gpb-new-label-rest"> bundle</span>
    </Link>
  );
}
